/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2022-12-01 13:27:51
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\specialmaterial\car.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/materials/car/queryPage'
export const batchUpdateOrDelete = '/icps/system/sign/intelligent/materials/car/updateEnable'
export const saveOrUpdate = '/icps/system/sign/intelligent/materials/car/saveOrUpdate'
// export function carMaintainsave(data) {
//   return request({
//     url: '/icps/system/sign/basics/carMaintain/save',
//     method: 'post',
//     data
//   })
// }
export function getCarContracts(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/car/getCarContracts',
    method: 'get',
    params
  })
}